import React, { useContext, useEffect, useState } from "react";
import "./Header.css";
import { Button, Container, Modal, Nav, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";
import { CookieName } from "../../utils/common";

function Header() {
  const [activeLink, setActiveLink] = useState("/dashboard"); // Set initial active link
  const [isNavbarOpen, setIsNavbarOpen] = useState(false); // State to control collapse behavior

  const handleNavClick = (path) => {
    setActiveLink(path); // Update active link when a link is clicked
    setIsNavbarOpen(false); // Close the navbar after a link is clicked
  };
  const [showModal, setShowModal] = useState(false);
  const {
    setUserData,
    setUsertype,
    setSignin,
    userdata,
    usertype,
    isSidebarOpen,
    setSidebarOpen,
    toggleSidebar,
    getData,
    IMG_URL,
    UnauthorizedLogOut,
  } = useContext(Context);

  const navigate = useNavigate();

  const LogOut = async () => {
    // await UnauthorizedLogOut();
    Cookies.remove(CookieName, { path: "/" });
    await setUserData("");
    await setUsertype("");
    await setSignin(false);
    navigate("/");
  };

  const location = useLocation();

  useEffect(() => {
    setActiveLink(location.pathname);
  });
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleLogoutClick = () => {
    setShowModal(true);
  };
  return (
    <section className="Header_holder">
      <Navbar expand="lg" className="Header">
        <Container fluid>
          <Navbar.Brand as={Link} to="/dashboard">
            <img
              className="header_logo"
              src={process.env.PUBLIC_URL + "/just_booking_logo.png"}
              alt="header_logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="navbarScroll"
            onClick={() => setIsNavbarOpen(!isNavbarOpen)} // Toggle navbar collapse state
          />
          <Navbar.Collapse
            className="ms-auto justify-content-end"
            id="navbarScroll"
            in={isNavbarOpen}
          >
            {" "}
            {/* Control collapse based on state */}
            {/* <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              <Nav.Link
                as={Link}
                to="/dashboard"
                className={activeLink === "/dashboard" ? "active" : ""}
                onClick={() => handleNavClick("/dashboard")}
              >
                <span className="icon-holder">
                  <img
                    className="icon-img"
                    src={process.env.PUBLIC_URL + "/Icon/dashboard.png"}
                    alt="icon-img"
                  />
                </span>
                Dashboard
              </Nav.Link>
            </Nav> */}
            <div className="header-side-icon-holder">
              <div className="admin_text_holder">
                <p>{userdata?.name}</p>
              </div>
              <Link to={"/"}>
                <div className="main-side-icon" onClick={handleLogoutClick}>
                  <div className="side-icon">
                    <FontAwesomeIcon className="icon" icon={faPowerOff} />
                  </div>
                </div>
              </Link>
            </div>
          </Navbar.Collapse>
        </Container>
        <Modal centered show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            {/* <Modal.Title>Confirm Logout</Modal.Title> */}
          </Modal.Header>
          <Modal.Body className="text-center">
            Are you sure you want to log out?
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={LogOut}>
              Logout
            </Button>
          </Modal.Footer>
        </Modal>
      </Navbar>
    </section>
  );
}

export default Header;
